<script lang="ts">
    export let el: HTMLInputElement
    export let label: string
    export let unitLabel: string
    export let min: number
    export let step: number
    export let disabled = false
    export let value: number
    export let color = 'black'

    export let hideInputs = false
    export let hideLabels = false
    export let hideUnits = false
</script>

<div class="w-full h-full" style="color: {color};">
    {#if !hideLabels}
        <span class="my-[5px] mx-0">{label}</span>
    {/if}
    {#if !hideInputs}
        <div class="input-icon">
            <span class="icon-container">
                <slot />
            </span>
            <input bind:this={el} on:input type="number" bind:value {min} {step} {disabled} class="text-black"/>
            {#if !hideUnits}
                <span class="help-block">{unitLabel}</span>
            {/if}
        </div>
    {/if}
</div>

<style lang="scss">
    .input-icon {
        position: relative;

        input {
            padding-left:30px !important;
            padding-right:-30px !important;
            margin-right:8px !important;
            width:100%;
            -moz-appearance: textfield;
            appearance: textfield;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        .icon-container {
            position: absolute;
            top: 50%;
            left: 8px;
            transform: translateY(-50%);
        }

        .help-block {
            font-size: 85%;
            margin: 0;
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
        }
    }
</style>